var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "error_svg__a",
    d: "M20 0C8.94 0 0 8.94 0 20s8.94 20 20 20 20-8.94 20-20S31.06 0 20 0zm10 27.18L27.18 30 20 22.82 12.82 30 10 27.18 17.18 20 10 12.82 12.82 10 20 17.18 27.18 10 30 12.82 22.82 20 30 27.18z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#E30513",
    fillRule: "evenodd",
    xlinkHref: "#error_svg__a"
  })));
};
export default __webpack_public_path__ + "static/media/error.760a41c2.svg";
export { SvgError as ReactComponent };